import React from 'react';
import Menu from '../components/menu';
import Icon from '../elements/icons';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import keinBild from "../css/image/ansprechpartner/keinBild.png";
import { Helmet } from 'react-helmet';
import Carusel from '../components/carusel';

class TagespflegeAmWaldkater extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }


    render() {
        window.scrollTo(0, 0);
        return (<>
            <Helmet>
                {/* Grundlegende Meta-Tags */}
                <meta charSet="utf-8" />
                <title>Tagespflege - Lebenshilfe Rinteln</title>
                <meta
                    name="description"
                    content="Die Tagespflege am Waldkater der Lebenshilfe Rinteln bietet liebevolle Betreuung und Unterstützung für Senioren und Menschen mit Pflegebedarf."
                />
                <meta
                    name="keywords"
                    content="Lebenshilfe Rinteln, Tagespflege, Tagesbetreuung, Pflege, Seniorenbetreuung, Waldkater"
                />
                <meta name="author" content="Lebenshilfe Rinteln" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta httpEquiv="X-UA-Compatible" content="IE=edge" />

                {/* Canonical Link */}
                <link rel="canonical" href="https://www.lebenshilfe-rinteln.de/tagespflegeamwaldkater" />

                {/* Open Graph Tags */}
                <meta property="og:title" content="Lebenshilfe Rinteln – Tagespflege am Waldkater" />
                <meta
                    property="og:description"
                    content="Liebevolle und professionelle Tagespflege am Waldkater für Senioren und Menschen mit Pflegebedarf bei Lebenshilfe Rinteln."
                />
                <meta property="og:url" content="https://www.lebenshilfe-rinteln.de/tagespflegeamwaldkater" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Lebenshilfe Rinteln" />

                {/* Twitter Cards */}
                <meta name="twitter:card" content="summary" />
                <meta name="twitter:title" content="Lebenshilfe Rinteln – Tagespflege am Waldkater" />
                <meta
                    name="twitter:description"
                    content="Professionelle und liebevolle Tagespflege für Senioren und Menschen mit Pflegebedarf bei Lebenshilfe Rinteln."
                />
            </Helmet>

            <div style={{ marginTop: "100px" }} className="animate__animated animate__fadeIn pb-5">

                {this.props.mobileVersion ? "" : <Menu {...this.props} />}

                {/* Hero Section */}
                <div className="container text-center shadow p-0 rounded overflow-hidden mt-3">
                    <h3 className="p-3 text-white bg-info m-0 ff-1 shadow-sm" style={{ background: "linear-gradient(135deg, #17a2b8, #117a8b)" }}>Tagespflege am Waldkater</h3>
                    <Carusel bilder={[
                        "/assets/tagespflege/0A1.jpg",
                        "/assets/tagespflege/0A2.jpg",
                        "/assets/tagespflege/0A3.jpg",
                        "/assets/tagespflege/0A4.png",
                        "/assets/tagespflege/0A5.jpg",
                        "/assets/tagespflege/0A6.jpg",
                    ]}
                        height="450px" width="100%" className="" />
                </div>

                <div className='container mt-5'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className="text-center ff-1 text-white shadow p-4 rounded mb-5" style={{ background: "linear-gradient(135deg, #17a2b8, #0e6c7c)" }}>
                                <h4 className="m-0" style={{ lineHeight: "1.5" }}>Sie fühlen sich in Ihrem Zuhause wohl, möchten oder können dort aber nicht den ganzen Tag über alleine sein?</h4>
                            </div>
                        </div>
                    </div>

                    <div className='row mb-5 d-flex align-items-stretch'>
                        <div className='col-md-6 mb-4 mb-md-0'>
                            <div className="bg-white rounded shadow-sm p-4 h-100 b-left-info custom-hover-card">
                                <h4 className="text-info mb-3 d-flex align-items-center">
                                    <div className="mr-2"><Icon icon="FaHome" /></div> Ein Ort zum Wohlfühlen
                                </h4>
                                <p className="text-secondary" style={{ fontSize: "1.05rem", lineHeight: "1.6" }}>Unsere im Frühjahr 2025 errichtete Tagespflege bietet Ihnen behaglich eingerichtete Räumlichkeiten, nette Gesellschaft und Abwechslung. Damit schaffen wir einen Ort, der zum Verweilen und gemeinsamen Zeitverbringen einlädt.</p>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="bg-white rounded shadow-sm p-4 h-100 b-left-warning custom-hover-card">
                                <h4 className="text-warning mb-3 d-flex align-items-center">
                                    <div className="mr-2"><Icon icon="FaSmileWink" /></div> Tägliche Abwechslung
                                </h4>
                                <p className="text-secondary" style={{ fontSize: "1.05rem", lineHeight: "1.6" }}>Täglich erwarten Sie wechselnde Angebote mit verschiedensten Aktivitäten, die individuell auf jeden Tagesgast abgestimmt sind. Sie können teilnehmen oder sich jederzeit zurückziehen und Ruhe genießen.</p>
                            </div>
                        </div>
                    </div>

                    <div className='bg-light rounded shadow-sm p-4 p-md-5 mb-5 border-top-info'>
                        <div className="text-center mb-5">
                            <h2 className="text-dark ff-1">Unsere Leistungen</h2>
                            <div className="bg-info mx-auto mt-2 mb-4" style={{ height: "4px", width: "70px", borderRadius: "2px" }}></div>
                            <p className="text-secondary mx-auto" style={{ maxWidth: "750px", fontSize: "1.1rem" }}>Mit unserer Tagespflege am Waldkater schließen wir eine Lücke zwischen Häuslichkeit und Pflegeheim. Wir unterstützen Sie dabei, selbstbestimmt am Leben teilzunehmen.</p>
                        </div>

                        <div className="row">
                            {[
                                { title: "Flexible Buchung", desc: "Einzelne Tage oder die ganze Woche nach Ihren Bedürfnissen.", icon: "FaCalendarAlt", color: "text-primary" },
                                { title: "Gemeinsame Mahlzeiten", desc: "Frühstück, Mittagessen und Kaffee in geselliger Runde.", icon: "FaCoffee", color: "text-warning" },
                                { title: "Persönliche Betreuung", desc: "Fachliches Pflegepersonal für Medikamentengabe und pflegerische Unterstützung.", icon: "FaUserNurse", color: "text-danger" },
                                { title: "Fahrdienst", desc: "Bequemer Hol- und Bringservice direkt von und nach Hause.", icon: "FaBusAlt", color: "text-success" },
                                { title: "Aktive Freizeit", desc: "Ausflüge, Bewegungsübungen, Spielen und gemeinsames Kochen.", icon: "FaPuzzlePiece", color: "text-info" },
                                { title: "Entlastung im Alltag", desc: "Wichtiger Freiraum und Entlastung für betreuende Angehörige.", icon: "FaHeart", color: "text-danger" }
                            ].map((item, index) => (
                                <div key={index} className="col-md-6 col-lg-4 mb-4">
                                    <div className="card h-100 border-0 shadow-sm custom-hover-card">
                                        <div className="card-body text-center p-4">
                                            <div className={`mb-3 ${item.color} icon-large`} style={{ fontSize: "2.5rem" }}>
                                                <Icon icon={item.icon} />
                                            </div>
                                            <h5 className="card-title font-weight-bold">{item.title}</h5>
                                            <p className="card-text text-muted">{item.desc}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="row mb-5">
                        <div className="col-12">
                            <div className="text-dark rounded shadow p-4 p-md-5 d-flex flex-column flex-md-row align-items-center justify-content-between gradient-warning">
                                <div className="mb-4 mb-md-0 flex-grow-1 pr-md-4">
                                    <h3 className="font-weight-bold mb-3 d-flex align-items-center">
                                        <div className="mr-2"><Icon icon="FaGift" /></div> Kostenloser Schnuppertag
                                    </h3>
                                    <p className="mb-0" style={{ fontSize: "1.1rem" }}>Machen Sie sich einen ersten Eindruck unserer Räumlichkeiten und lernen Sie unser Pflegepersonal kennen. Falls es Ihnen zusagt, vereinbaren wir direkt einen unverbindlichen und kostenlosen Schnuppertag!</p>
                                </div>
                                <div className="ml-md-4">
                                    <Link to="/kontakt" className="btn btn-dark btn-lg shadow rounded px-4 py-3 font-weight-bold text-nowrap modern-btn">Jetzt Termin vereinbaren</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mb-5 justify-content-center">
                        <div className="col-12 col-lg-10 text-center">
                            <div className="p-4 bg-white rounded shadow-sm border" style={{ borderColor: "#e9ecef" }}>
                                <h4 className="font-italic text-secondary m-0" style={{ lineHeight: "1.6" }}>
                                    "Sie möchten weiterhin in Ihrem Zuhause leben, Selbstbestimmung und Lebensqualität genießen und benötigen dabei Unterstützung? <strong className="text-info">Dann sind Sie bei uns in der Tagespflege am Waldkater genau richtig.</strong>"
                                </h4>
                            </div>
                        </div>
                    </div>

                    {/* Ansprechpartner Card */}
                    <div className="row m-0 justify-content-center mb-4">
                        <div className="col-12 col-lg-10 bg-white shadow rounded p-0 overflow-hidden contact-card">
                            <div className="bg-info p-3 text-white text-center font-weight-bold" style={{ fontSize: "1.2rem", letterSpacing: "1px" }}>
                                <div className="d-flex align-items-center justify-content-center">
                                    <div className="mr-2"><Icon icon="Person" /></div> Ihr Ansprechpartner
                                </div>
                            </div>
                            <div className="row m-0 p-4 p-md-5 align-items-center">
                                <div className="col-12 col-md-5 text-center mb-4 mb-md-0">
                                    <div className="position-relative d-inline-block">
                                        <img src={keinBild} className="rounded-circle shadow-sm" style={{ width: "200px", height: "200px", objectFit: "cover", border: "5px solid #fff" }} alt="Miriam Böger" />
                                    </div>
                                </div>
                                <div className="col-12 col-md-7 text-center text-md-left text-secondary pl-md-4">
                                    <h2 className="text-dark font-weight-bold mb-1">Miriam Böger</h2>
                                    <h5 className="text-info mb-4">Pflegedienstleitung</h5>

                                    <div className="d-flex align-items-center justify-content-center justify-content-md-start mb-3" style={{ fontSize: "1.1rem" }}>
                                        <div className="bg-light rounded-circle p-2 mr-3 text-info shadow-sm d-flex align-items-center justify-content-center" style={{ width: "45px", height: "45px" }}>
                                            <Icon icon="Phone" />
                                        </div>
                                        <span className="font-weight-bold text-dark">05751-89104750</span>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-center justify-content-md-start mb-4" style={{ fontSize: "1.1rem" }}>
                                        <div className="bg-light rounded-circle p-2 mr-3 text-info shadow-sm d-flex align-items-center justify-content-center" style={{ width: "45px", height: "45px" }}>
                                            <Icon icon="Mail" />
                                        </div>
                                        <a href="mailto:m.boeger@lebenshilfe-rinteln.de" className="text-info font-weight-bold" style={{ textDecoration: "underline" }}>m.boeger@lebenshilfe-rinteln.de</a>
                                    </div>

                                    <div className="p-3 bg-light rounded text-left border-left-quote">
                                        <p className="m-0 font-italic">„Das Team der Tagespflege am Waldkater besteht aus Fachkräften, Pflegehelfern und Betreuungskräften, die sich um Ihr Wohl kümmern. Pflege ist das tägliche Geschenk an jene, die uns am meisten brauchen.“</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                {/* Inline CSS for specific component styles */}
                <style dangerouslySetInnerHTML={{
                    __html: `
                    .custom-hover-card {
                        transition: all 0.3s ease;
                        border: 1px solid #f8f9fa;
                    }
                    .custom-hover-card:hover {
                        transform: translateY(-8px);
                        box-shadow: 0 1rem 3rem rgba(0,0,0,.15)!important;
                        border-color: #e9ecef;
                    }
                    .b-left-info { border-left: 5px solid #17a2b8; }
                    .b-left-warning { border-left: 5px solid #ffc107; }
                    .border-top-info { border-top: 5px solid #17a2b8; }
                    .border-left-quote { border-left: 4px solid #17a2b8; }
                    .gradient-warning { background: linear-gradient(135deg, #ffc107, #ffb300); }
                    .modern-btn {
                        transition: all 0.2s ease;
                        border-radius: 50px !important;
                    }
                    .modern-btn:hover {
                        transform: translateY(-3px);
                        box-shadow: 0 0.5rem 1.5rem rgba(0,0,0,.2)!important;
                        background-color: #212529;
                    }
                    .icon-large { transition: transform 0.3s ease; }
                    .custom-hover-card:hover .icon-large { transform: scale(1.15); }
                    .contact-card { transition: all 0.3s ease; }
                    .contact-card:hover { box-shadow: 0 1rem 3rem rgba(0,0,0,.15)!important; }
                `}} />
            </div>
        </>);
    }
}

export default TagespflegeAmWaldkater;